import { useMemo } from "react"
import { License } from "../constants/license.enum"
import { Role } from "../constants/role.enum"
import { CompanyT } from "../store/slices/company.slice"
import { useAppSelector } from "./useRedux"
import { useSession } from "./useSession"
import { UserRole } from "../constants/roles.enum"

export const useWorkspacePermission = (selectedCompany?: CompanyT | null) => {
    const user = useAppSelector((state) => state.user.value)
    const companies = useAppSelector((state) => state.companies)
    const companiesStats = useAppSelector((state) => state.companiesStats)
    const { hasRole } = useSession()

    const workspaceIsExpired =
        selectedCompany?.expired && selectedCompany.expired?.getTime() < Date.now()

    const userHaveActiveLicense =
        user.license?.expired === null ||
        (user.license?.expired && new Date(user.license.expired).getTime() > Date.now())

    const companyUserRole = selectedCompany?.usersRef.find((u) => u.id === user._id)?.role

    //number of active members, it means with isDisabled: undefined || false
    // const numberOfWorkspacesMember = selectedCompany?.usersRef.length ?? 0

    const isOwner = selectedCompany?.userId === user._id

    //company permission

    //create workspace can super admin
    //user with not expired license
    const canCreateWorkspace =
        hasRole(UserRole.Admin) ||
        (userHaveActiveLicense && user.license?.license === License.Enterprise)

    //update workspace can Super Admin, workspace is not expired
    //and workspace have Enterprise | Business | Individual license
    //and user is part of workspace and have Role high as Collaborator
    const canUpdateWorkspace =
        !companies.status ||
        !companiesStats.status ||
        hasRole(UserRole.Admin) ||
        (!workspaceIsExpired &&
            selectedCompany?.license === License.Enterprise &&
            selectedCompany?.usersRef.some((u) => u.id === user._id) &&
            companyUserRole &&
            companyUserRole > Role.Collaborator)

    const canModifiedWorkspace = useMemo(() => {
        if ((selectedCompany?._id && canUpdateWorkspace) || canCreateWorkspace) {
            return true
        } else {
            return false
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [selectedCompany])

    //canPushUser
    const canInviteUser =
        hasRole(UserRole.Admin) ||
        (!workspaceIsExpired &&
            companyUserRole &&
            companyUserRole > Role.Collaborator &&
            selectedCompany?.license === License.Enterprise)

    const canRemoveUser =
        hasRole(UserRole.Admin) ||
        (!workspaceIsExpired &&
            companyUserRole &&
            companyUserRole > Role.Collaborator &&
            selectedCompany?.license === License.Enterprise)

    const canDeleteWorkspace = hasRole(UserRole.Admin) || isOwner
    const isPrivate = selectedCompany?.isPrivate
    const expiredOwnerCompanyLicense = !isPrivate && isOwner && workspaceIsExpired
    const expiredParticipantCompanyLicense = !isPrivate && !isOwner && workspaceIsExpired

    return {
        expiredOwnerCompanyLicense,
        expiredParticipantCompanyLicense,
        userHaveActiveLicense,
        canCreateWorkspace,
        canInviteUser,
        canUpdateWorkspace,
        workspaceIsExpired,
        canRemoveUser,
        canDeleteWorkspace,
        canModifiedWorkspace,
    }
}
